/* ============================================================
   tio-packs.js — cover-flow de "Promociones" (seccion tio-packs).

   El gesto TACTIL no se toca: es scroll-snap nativo del navegador
   (60fps, inercia de iOS). Cero JS en el touch, y por eso nunca se come
   un tap sobre el quick-add.

   El JS solo agrega lo que el navegador no da:
     - arranque en la tarjeta del MEDIO (el diseno arranca ahi)
     - marca .is-active en la tarjeta centrada
     - vuelca sus data-title / data-brand / data-price en la caja de
       metadatos inferior, con el fade del diseno (.is-out)
     - flechas de desktop y arrastre con MOUSE, con inercia al soltar

   Doctrina 8.1: listeners DELEGADOS en document. El editor de temas
   re-monta secciones enteras y los handlers por elemento mueren con el
   nodo. Aca no hay ni un addEventListener por tarjeta.

   VALORES LITERALES DEL DISENO (PacksCoverflow en home-frame.html):
     animTo dur = 560ms · ease-in-out cubico · setInterval 16ms
     fade de la caja de metadatos = 150ms
     umbral de arrastre real = 6px · proyeccion de inercia = v * 170
   ============================================================ */
(function () {
  'use strict';

  var DUR = 560;      /* duracion del glide a la tarjeta destino */
  var FADE = 150;     /* espera antes de volcar el texto nuevo */
  var UMBRAL = 6;     /* px para considerar que hubo arrastre real */
  var IMPULSO = 170;  /* factor de proyeccion de la inercia al soltar */

  /* ease-in-out cubico, literal del diseno: arranca y frena suave. */
  function suavizar(x) {
    if (x < 0.5) return 4 * x * x * x;
    return 1 - Math.pow(-2 * x + 2, 3) / 2;
  }

  var animaciones = new WeakMap();  /* pista -> id de setInterval */
  var relojes = new WeakMap();      /* pista -> timeout del fade */
  var indices = new WeakMap();      /* pista -> indice activo */
  var pendientes = new WeakSet();   /* pista -> ya hay un recalculo agendado */

  var arrastre = null;
  var suprimirClic = false;

  function pista(pcf) { return pcf.querySelector('[data-tio-pcf-pista]'); }

  /* Indice de la tarjeta mas cercana al centro (la pista lleva un padding
     lateral igual a la mitad del hueco sobrante, asi que el offset de la
     tarjeta centrada ES el scrollLeft). */
  function indiceCentrado(el) {
    var hijos = el.children;
    if (!hijos.length) return 0;
    var base = hijos[0].offsetLeft;
    var mejor = 0;
    var mejorD = Infinity;
    for (var i = 0; i < hijos.length; i++) {
      var d = Math.abs((hijos[i].offsetLeft - base) - el.scrollLeft);
      if (d < mejorD) { mejorD = d; mejor = i; }
    }
    return mejor;
  }

  function volcarMeta(pcf, tarjeta) {
    var titulo = pcf.querySelector('[data-tio-pcf-titulo]');
    var marca = pcf.querySelector('[data-tio-pcf-marca]');
    var precio = pcf.querySelector('[data-tio-pcf-precio]');
    if (titulo) titulo.textContent = tarjeta.getAttribute('data-title') || '';
    if (marca) marca.textContent = tarjeta.getAttribute('data-brand') || '';
    if (precio) precio.textContent = tarjeta.getAttribute('data-price') || '';
  }

  /* Marca la tarjeta centrada y vuelca sus datos en la caja inferior.
     instantaneo = true para el arranque: sin fade, porque el texto que
     pinto el servidor todavia no se vio moverse. */
  function aplicarActivo(pcf, n, instantaneo) {
    var el = pista(pcf);
    if (!el) return;
    var hijos = el.children;
    if (!hijos.length) return;
    if (n < 0) n = 0;
    if (n > hijos.length - 1) n = hijos.length - 1;

    var previo = indices.has(el) ? indices.get(el) : 0;
    if (!instantaneo && n === previo) return;
    indices.set(el, n);

    for (var i = 0; i < hijos.length; i++) {
      if (i === n) hijos[i].classList.add('is-active');
      else hijos[i].classList.remove('is-active');
    }

    var caja = pcf.querySelector('[data-tio-pcf-meta]');
    if (!caja) return;

    clearTimeout(relojes.get(el));
    if (instantaneo) {
      caja.classList.remove('is-out');
      volcarMeta(pcf, hijos[n]);
      return;
    }

    caja.classList.add('is-out');
    relojes.set(el, setTimeout(function () {
      volcarMeta(pcf, hijos[n]);
      caja.classList.remove('is-out');
    }, FADE));
  }

  function actualizar(el) {
    var pcf = el.closest('[data-tio-pcf]');
    if (pcf) aplicarActivo(pcf, indiceCentrado(el), false);
  }

  /* Estrangulado a ~1 recalculo por frame: durante un swipe brusco el
     scroll dispara MUCHISIMOS eventos y el trabajo no debe competir con
     el scroll nativo.
     rAF se estrangula dentro de iframes (el editor de temas es uno), asi
     que corre tambien un setTimeout: gana el primero que dispare y el
     otro queda sin efecto. */
  function agendar(el) {
    if (pendientes.has(el)) return;
    pendientes.add(el);
    var correr = function () {
      if (!pendientes.has(el)) return;
      pendientes.delete(el);
      actualizar(el);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(correr);
    setTimeout(correr, 32);
  }

  /* Glide por setInterval, no requestAnimationFrame: rAF se estrangula
     dentro de iframes y dejaba las flechas sin mover. El snap se apaga
     mientras dura la animacion para que no pelee con ella (evita el
     "brusco"), y se restaura al terminar. */
  function animarHasta(el, destino) {
    clearInterval(animaciones.get(el));
    var max = el.scrollWidth - el.clientWidth;
    var fin = Math.max(0, Math.min(max, destino));
    var ini = el.scrollLeft;
    var dist = fin - ini;
    if (Math.abs(dist) < 1) { el.style.scrollSnapType = ''; return; }
    /* reduced-motion: el glide se salta al destino. El !important de
       tio-tokens.css solo alcanza a las animaciones CSS, no a esta. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.scrollLeft = fin;
      el.style.scrollSnapType = '';
      return;
    }
    el.style.scrollSnapType = 'none';
    var t0 = Date.now();
    var id = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / DUR);
      el.scrollLeft = ini + dist * suavizar(p);
      if (p >= 1) {
        clearInterval(id);
        el.style.scrollSnapType = '';
      }
    }, 16);
    animaciones.set(el, id);
  }

  function irA(pcf, i) {
    var el = pista(pcf);
    if (!el || !el.children.length) return;
    var n = Math.max(0, Math.min(el.children.length - 1, i));
    var base = el.children[0].offsetLeft;
    animarHasta(el, el.children[n].offsetLeft - base);
  }

  /* ---------------- Clics: flechas y tarjetas (delegado) ----------------
     El diseno hacia stopPropagation en el quick-add para no disparar el
     goTo de la tarjeta. Con listeners delegados el equivalente correcto
     es IGNORAR aca los clics nacidos dentro de [data-te-add]: un
     stopPropagation de verdad tambien mataria al Quick View, que escucha
     delegado en este mismo document. */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-tio-pcf-prev]');
    var next = e.target.closest('[data-tio-pcf-next]');
    if (prev || next) {
      var caja = (prev || next).closest('[data-tio-pcf]');
      if (!caja) return;
      var lista = pista(caja);
      if (!lista) return;
      irA(caja, indiceCentrado(lista) + (next ? 1 : -1));
      return;
    }

    if (e.target.closest('[data-te-add]')) return;

    var tarjeta = e.target.closest('[data-tio-pcf-tarjeta]');
    if (!tarjeta) return;
    var pcf = tarjeta.closest('[data-tio-pcf]');
    if (!pcf) return;
    var el = pista(pcf);
    if (!el) return;
    irA(pcf, Array.prototype.indexOf.call(el.children, tarjeta));
  });

  /* Suprime SOLO el clic que cierra un arrastre real, para no romper el
     quick-add ni un clic normal sobre la tarjeta. Va en CAPTURA sobre
     document: asi corre antes que el listener del Quick View (burbuja) y
     lo frena tambien a el. */
  document.addEventListener('click', function (e) {
    if (!suprimirClic) return;
    suprimirClic = false;
    if (!e.target.closest('[data-tio-pcf-pista]')) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  /* ---------------- Tarjeta centrada (listener pasivo) ----------------
     scroll no burbujea: se escucha en CAPTURA desde document. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-tio-pcf-pista')) return;
    agendar(el);
  }, { capture: true, passive: true });

  /* ---------------- Arrastre con MOUSE ----------------
     Solo mouse: el tactil sigue 100% nativo. */
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    var el = e.target.closest('[data-tio-pcf-pista]');
    if (!el) return;
    clearInterval(animaciones.get(el));
    suprimirClic = false;
    arrastre = { el: el, x: e.clientX, left: el.scrollLeft, movido: false, ultX: e.clientX, ultT: Date.now(), v: 0 };
  });

  document.addEventListener('pointermove', function (e) {
    if (!arrastre) return;
    var dx = e.clientX - arrastre.x;
    if (!arrastre.movido && Math.abs(dx) > UMBRAL) {
      arrastre.movido = true;
      arrastre.el.style.scrollSnapType = 'none';
      arrastre.el.classList.add('is-dragging');
    }
    if (arrastre.movido) {
      arrastre.el.scrollLeft = arrastre.left - dx;
      var ahora = Date.now();
      var dt = ahora - arrastre.ultT;
      if (dt > 0) arrastre.v = (e.clientX - arrastre.ultX) / dt;
      arrastre.ultX = e.clientX;
      arrastre.ultT = ahora;
    }
  });

  function soltar() {
    if (!arrastre) return;
    var a = arrastre;
    arrastre = null;
    var el = a.el;
    el.classList.remove('is-dragging');
    if (!a.movido) { el.style.scrollSnapType = ''; return; }

    var hijos = el.children;
    if (!hijos.length) { el.style.scrollSnapType = ''; return; }

    /* Proyeccion por inercia: no corta en seco, sigue flotando hasta la
       tarjeta que corresponde al impulso. */
    var base = hijos[0].offsetLeft;
    var paso = hijos.length > 1 ? (hijos[1].offsetLeft - hijos[0].offsetLeft) : el.clientWidth;
    var proyectado = el.scrollLeft + (-a.v) * IMPULSO;
    var n = paso > 0 ? Math.round(proyectado / paso) : 0;
    n = Math.max(0, Math.min(hijos.length - 1, n));

    suprimirClic = true;
    animarHasta(el, hijos[n].offsetLeft - base);
  }

  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);

  /* ---------------- Arranque ----------------
     El servidor deja centrada y activa la PRIMERA tarjeta (estado base
     coherente sin JS). El diseno arranca en la del MEDIO: eso es un
     enriquecimiento y se aplica aca, sin animacion y sin fade. */
  function iniciar() {
    var lista = document.querySelectorAll('[data-tio-pcf]');
    for (var i = 0; i < lista.length; i++) {
      var pcf = lista[i];
      var el = pista(pcf);
      if (!el || !el.children.length) continue;
      var medio = Math.floor((el.children.length - 1) / 2);
      el.scrollLeft = el.children[medio].offsetLeft - el.children[0].offsetLeft;
      aplicarActivo(pcf, medio, true);
    }
  }

  /* En resize NO se re-centra (el diseno tampoco): solo se recalcula cual
     tarjeta quedo al centro, porque el ancho de tarjeta es 55vw en movil. */
  function recalcular() {
    var lista = document.querySelectorAll('[data-tio-pcf-pista]');
    for (var i = 0; i < lista.length; i++) agendar(lista[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  window.addEventListener('resize', recalcular, { passive: true });
  document.addEventListener('shopify:section:load', iniciar);
})();
